module.exports = __webpack_public_path__ + "img/1O.8abf6696.jpg";